import React, { FC, MouseEvent } from 'react'
import { Link } from '@components/Link'
import { LinkBlockWrapper } from './LinkBlock.elements'

type Props = {
  link: string
  onAction?: () => void
  onClick?: () => void
  textColor?: string
}

export const LinkBlock: FC<Props> = ({
  link,
  onAction,
  onClick,
  textColor,
}) => {
  const handleAction = (event: MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    onAction && onAction()
    onClick && onClick()
  }

  return (
    <LinkBlockWrapper>
      <Link
        onClick={handleAction}
        inverted={textColor === 'white'}
        aria-label="See details"
      >
        {link}
      </Link>
    </LinkBlockWrapper>
  )
}
